























import {Component, Vue, Watch} from 'vue-property-decorator';
import HowToNav from '@/components/howto/HowToNav.vue';
import {Route} from 'vue-router';
import HowToAbout from '@/components/howto/HowToAbout.vue';
import HowToCharacter from '@/components/howto/HowToCharacter.vue';
import HowToGameMode from '@/components/howto/HowToGameMode.vue';
import HowToVip from '@/components/howto/HowToVip.vue';

@Component({
  components: {
    HowToGameMode,
    HowToCharacter,
    HowToAbout,
    HowToNav,
    HowToVip
  },
})
export default class HowTo extends Vue{
  section = 'about';

  created(): void {
    this.updateSection(this.$route)
  }

  @Watch('$route')
  onRouterChange(to: Route): void {
    this.updateSection(to)
  }

  updateSection(to: Route): void {
    if (to.params.section) {
      this.section = to.params.section;
    } else {
      this.section = 'about';
    }
  }

}
